import React from "react";

const MARKDOWN_REGEX = /(!?)\[([^\]]*)\]\((https?:\/\/[^\s)]+)(?:\s+=(\d+)x(\d+))?\)/g;

const renderMatch = (match: RegExpMatchArray): React.ReactNode => {
  const [, marker, label, url, widthStr, heightStr] = match;
  const key = match.index;
  if (marker === "!") {
    const width = widthStr ? parseInt(widthStr, 10) : undefined;
    const height = heightStr ? parseInt(heightStr, 10) : undefined;
    return (
      <img
        key={key}
        src={url}
        alt={label}
        referrerPolicy="no-referrer"
        style={{ maxWidth: "100%", height: height ?? "auto", width, display: "block", margin: "4px 0" }}
      />
    );
  }
  return (
    <a
      key={key}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#1976d2", textDecoration: "none" }}
      onMouseEnter={(e) => { (e.target as HTMLElement).style.textDecoration = "underline"; }}
      onMouseLeave={(e) => { (e.target as HTMLElement).style.textDecoration = "none"; }}
    >
      {label}
    </a>
  );
};

const LinkifiedText: React.VFC<{ text: string }> = ({ text }) => {
  const matches = Array.from(text.matchAll(MARKDOWN_REGEX));
  if (matches.length === 0) return <>{text}</>;

  const { parts, cursor } = matches.reduce<{ parts: React.ReactNode[]; cursor: number }>(
    (acc, match) => {
      const start = match.index ?? 0;
      const next = [...acc.parts];
      if (start > acc.cursor) next.push(text.slice(acc.cursor, start));
      next.push(renderMatch(match));
      return { parts: next, cursor: start + match[0].length };
    },
    { parts: [], cursor: 0 }
  );

  return <>{cursor < text.length ? [...parts, text.slice(cursor)] : parts}</>;
};

export default LinkifiedText;
